exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{margin:0}a{display:block;text-decoration:none;font-family:Arial, Helvetica, sans-serif;margin-bottom:10px;height:30px;line-height:30px;padding:0 16px;font-size:12px;font-weight:600;text-transform:uppercase;border-radius:8px;text-align:center}a.primary{color:#FFF;border:2px solid transparent;margin-right:10px}a.secondary{border:2px solid}.previewcontainer{display:flex;margin-top:10px}.new-msg{font-size:16px;color:#848484;text-align:center}\n", ""]);

// exports
